import { render, staticRenderFns } from "./EpisodesList.vue?vue&type=template&id=471e7f19&scoped=true&"
import script from "./EpisodesList.vue?vue&type=script&lang=js&"
export * from "./EpisodesList.vue?vue&type=script&lang=js&"
import style1 from "./EpisodesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471e7f19",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VImg,VList,VListItem,VListItemAvatar,VListItemTitle,VSelect})
